import appStore from './appStore'
const store = {
  appStore
}
export default store